// Import services
import { travelService } from './services/travelService';
import { backupRegistry } from '@trip-planner-monorepo/shared';
import { db } from '@trip-planner-monorepo/shared';
import { doc, setDoc } from 'firebase/firestore';

// Export initialization function
export const initTravelServices = () => {
  // Register backup capabilities with the backup registry
  backupRegistry.register('travel', {
    fetchAll: async (userId, tripId) => {
      console.log(`[Travel] Fetching all travel for backup: userId=${userId}, tripId=${tripId}`);
      return await travelService.fetchTravel(userId, tripId);
    },
    restoreAll: async (userId, tripId, data) => {
      console.log(`[Travel] Restoring ${data.length} travel items for trip ${tripId}`);

      // Data is an array of travel documents from backup
      for (const travelData of data) {
        try {
          // Preserve original ID by using setDoc instead of addDoc
          const travelRef = doc(db, 'users', userId, 'trips', tripId, 'travel', travelData.id);

          // Remove the id from the data object (it's already in the document reference)
          const { id, ...travelDataWithoutId } = travelData;

          // Use setDoc to create/overwrite document with preserved ID
          await setDoc(travelRef, {
            ...travelDataWithoutId,
            updatedAt: new Date().toISOString()
          });

          console.log(`[Travel] Restored travel ${travelData.id} (${travelData.type}: ${travelData.summary || 'no summary'})`);
        } catch (error) {
          console.error(`[Travel] Error restoring travel ${travelData.id}:`, error);
          throw error;
        }
      }

      console.log(`[Travel] Successfully restored ${data.length} travel items`);
    },
    version: '1.0'
  });

  console.log('[Travel] Registered with backup registry');

  // Initialize the travel service
  travelService.init();
  console.log('Travel services initialized');
};

// Export services
export { travelService };
export { flightDataService } from './services/flightDataService';

// Export components
export { default as TravelList } from './components/TravelList.jsx';
export { default as TravelDetails } from './components/TravelDetails/TravelDetails.jsx';
export { default as AddTravel } from './components/AddTravel/AddTravel.jsx';

// Export utils
export * as busUtils from './components/busUtils';
export * as trainUtils from './components/trainUtils';
export * as flightUtils from './components/flightUtils'; 